import React from "react";
import { Alert, Statistic } from "antd";

const money = (n) => `${Number(n || 0).toLocaleString("vi-VN")}đ`;

// Chữ tiếng Việt cho lý do loại — BE trả mã, admin cần đọc được ngay tại form.
// Cố ý ngắn hơn reward-reason-labels (bảng kia viết cho USER đọc, đây cho admin).
const REASON_TEXT = {
    NOT_NEW_USER: "không phải khách mới",
    NOT_FIRST_ORDER: "không phải đơn đầu tiên",
    ORDER_VALUE_TOO_LOW: "đơn chưa đạt mốc giá trị",
    ORDER_VALUE_UNKNOWN: "chưa có dữ liệu giá trị đơn",
    CAMP_NOT_INCLUDED: "sàn không nằm trong đợt",
    OUT_OF_WINDOW: "ngoài cửa sổ thời gian",
    WEB_CHANNEL: "đơn mua qua web",
    BUFF_ORDER: "đơn nội bộ",
    CHANNEL_UNKNOWN: "đơn không rõ nguồn app",
    ALREADY_MULTIPLIED: "đã nhân hệ số ở đợt khác",
    TIER_NOT_UNLOCKED: "chưa đủ điều kiện mở khoá",
    TIER_BLOCKED_BY_CANCEL: "có đơn huỷ gần đây",
    ORDER_ABOVE_FAST_CAP: "vượt mức hoàn nhanh",
    ALREADY_PAID: "đã hoàn tiền theo lịch thường",
};

/**
 * EstimatePanel — kết quả chạy thử cấu hình đợt trên đơn N ngày gần nhất.
 * Số do BE tính bằng ĐÚNG engine chốt lô (admin-program-estimate) — FE chỉ hiển thị.
 */
function EstimatePanel({ estimate: e }) {
    const lossPct = e.granted ? Math.round((e.lossCount / e.granted) * 100) : 0;

    return (
        <div className="border border-blue-200 bg-blue-50 rounded-lg p-4 space-y-3">
            <div className="font-medium text-blue-900">
                Ước lượng trên {e.scanned.toLocaleString("vi-VN")} đơn app của {e.days} ngày gần nhất
                {/* Bấm lại cùng cấu hình trong 5 phút sẽ trả bản lưu — nói rõ để admin
                    không tưởng số đứng im là hỏng, và biết cách lấy số mới (đổi cấu hình). */}
                {e.cachedAt && (
                    <span className="ml-2 text-xs font-normal text-blue-700">
                        (số đã tính lúc {new Date(e.cachedAt * 1000).toLocaleTimeString("vi-VN")}, lưu 5 phút)
                    </span>
                )}
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <Statistic title="Người được thưởng" value={e.users ?? e.granted} suffix={`/${e.days} ngày`} />
                <Statistic title="Tổng chi" value={money(e.spend)} />
                <Statistic
                    title="Tiền túi phải bù"
                    value={money(e.loss)}
                    valueStyle={{ color: e.loss > e.spend / 2 ? "#cf1322" : undefined }}
                />
                <Statistic title="Ngân sách chạy được" value={e.burnDays ? `~${e.burnDays} ngày` : "—"} />
            </div>

            <div className="text-sm text-content-2 space-y-1">
                <div>
                    Đủ điều kiện <b>{e.eligible.toLocaleString("vi-VN")}</b> đơn — cấp được{" "}
                    <b>{e.granted.toLocaleString("vi-VN")}</b>
                    {e.outOfBudget > 0 && <> , trượt <b>{e.outOfBudget.toLocaleString("vi-VN")}</b> đơn (hết quỹ hoặc đã nhận rồi)</>}.
                </div>
                {e.granted > 0 && (
                    <div>
                        <b>{e.lossCount.toLocaleString("vi-VN")}</b> đơn ({lossPct}%) có tiền thưởng vượt hoa hồng của chính đơn đó —
                        trung bình bù <b>{money(e.lossPerUser)}</b> mỗi người.
                    </div>
                )}
                {e.budgetExhausted && <div className="text-orange-600">Ngân sách cạn TRƯỚC khi hết cửa sổ dữ liệu.</div>}
            </div>

            {/* Lý do loại nhiều nhất — cho biết siết/nới điều kiện nào là hiệu quả nhất */}
            {e.reasons && Object.keys(e.reasons).length > 0 && (
                <div className="text-xs text-content-3">
                    Đơn bị loại:{" "}
                    {Object.entries(e.reasons)
                        .sort((a, b) => b[1] - a[1])
                        .slice(0, 5)
                        .map(([r, c]) => `${c.toLocaleString("vi-VN")} ${REASON_TEXT[r] || r}`)
                        .join(" · ")}
                </div>
            )}

            {Array.isArray(e.caveats) && e.caveats.length > 0 && (
                <Alert type="info" showIcon message={e.caveats.join(" ")} />
            )}
        </div>
    );
}

export default EstimatePanel;
